<template>
  <div
    v-if="
      this.$store.getters['authorization/acl'].hasPermission('callback_access')
    "
    class="PlatformCallbackView"
  >
    <ShPageHeader
      title="Lista połączeń do oddzwonienia"
      :description="`Lista wszystkich połączeń do oddzwonienia dla danego projektu`"
      :breadcrumb-items="[
        { label: 'zarządzanie' },
        { label: 'lista połączeń', path: '/callback' },
      ]"
    />
    <CallbackFilters
      :project-list="projectList"
      @changeProject="handleChangeProject"
    />
    <EffectFilters
      v-if="callbackList.length !== 0"
      :effect-list="connectionEffectsList"
      @changeEffect="handleEffectFilter"
    />
    <ProgressBar
      v-if="filteredCallbackList.length !== 0"
      :is-active="!isTakingNewData"
      :interval="30"
      @fetchData="refreshCallbackList"
    />
    <CallbackList
      :callback-list="filteredCallbackList"
      :project-name="projectName"
      :agent-list="agentsBelongsToUserAgents"
    />
  </div>
</template>

<script>
import { hDeepCopy } from "@/utils/helpers";
import CallbackList from "@/components/Callback/CallbackList";
import CallbackFilters from "@/components/Callback/CallbackFilters";
import EffectFilters from "@/components/Callback/EffectFilters";
import ProgressBar from "@/components/Dashboard/ProgressBar";

export default {
  name: "PlatformCallback",
  components: {
    CallbackFilters,
    CallbackList,
    EffectFilters,
    ProgressBar,
  },
  data() {
    return {
      callbackEffectFilter: "",
      selectedProject: null,
    };
  },
  computed: {
    isTakingNewData() {
      return this.$store.getters["global/pendingAsyncStoreActions"].includes([
        "callback/getList",
      ]);
    },
    connectionEffectsList() {
      return this.$store.getters["connections/effects/list"].records.filter(
        (item) => item.is_for_callback
      );
    },
    callbackList() {
      return hDeepCopy(this.$store.getters["callback/list"]?.records);
    },
    filteredCallbackList() {
      return this.callbackEffectFilter === ""
        ? this.callbackList
        : this.callbackList.filter(
            (item) => item.status === this.callbackEffectFilter
          );
    },
    userData() {
      return this.$store.getters["authorization/user"];
    },
    projectList() {
      if (
        this.$store.getters["authorization/acl"].hasPermission(
          "callback_list_for_all_projects_access"
        )
      ) {
        return this.$store.getters["client/projects/list"]?.records;
      }
      let filteredProjects = this.$store.getters[
        "client/projects/list"
      ]?.records.filter((item) =>
        this.agentsBelongsToUserAgents.some(
          (agent) => agent.project_uuid === item.uuid
        )
      );
      return filteredProjects;
    },
    projectName() {
      return hDeepCopy(this.$store.getters["callback/project"]);
    },
    agentsBelongsToUserAgents() {
      return hDeepCopy(
        this.$store.getters["user/agent/agentsBelongsToUserlist"].records
      );
    },
    isLoading() {
      return this.$store.getters["global/pendingAsyncStoreActions"].includes([
        "callback/getList",
      ]);
    },
  },

  async created() {
    await this.$store.dispatch(
      "client/projects/getList",
      this.userData.client.uuid
    );
    await this.$store.dispatch("connections/effects/getEffectList");
  },

  methods: {
    async handleChangeProject(project) {
      this.selectedProject = project;
      const projectName = this.projectList.filter(
        (item) => item.uuid === project
      )[0].name;
      this.$store.commit("callback/FILL_PROJECT", projectName);
      await this.$store.dispatch("callback/getList", project);
    },
    handleEffectFilter(callbackStatus) {
      this.callbackEffectFilter = callbackStatus;
    },
    async refreshCallbackList() {
      if (this.selectedProject) {
        await this.$store.dispatch("callback/getList", this.selectedProject);
      }
    },
  },
};
</script>

<style lang="sass" scoped>
.PlatformCallbackView
  margin: 20px
</style>
